(function ($) {
    // On DOM ready
    $('.three-column-grid .col-wrapper .card-outer .card-box .img-content h3').matchHeight();
    $(document).ready(function () {

        $('body .three-column-grid .col-wrapper .card-outer .card-box a').click(function (e) {
            e.preventDefault();
        });


        $('.three-column-grid .col-wrapper .card-outer').on('mouseenter', function() {
            var $this = $(this).find(".hover-box .img-box, .hover-box h3, .hover-box p");

        });
        $('.three-column-grid .col-wrapper .card-outer').on('mouseleave',function(){
            $(this).find(".hover-box .img-box, .hover-box h3, .hover-box p").removeClass('is-revealed');
        });
    });
})(jQuery);